export class AppError extends Error {
  public readonly name: string;

  public readonly statusCode: string | number;

  public readonly isOperational: boolean;

  public readonly clientMessage: string;

  public readonly details?: unknown;

  constructor(
    name: string,
    statusCode: string | number,
    description: string,
    isOperational: boolean,
    clientMessage?: string,
    details?: unknown
  ) {
    super(description);

    Object.setPrototypeOf(this, new.target.prototype); // restore prototype chain

    this.name = name;
    this.statusCode = statusCode;
    this.isOperational = isOperational;
    this.clientMessage = clientMessage || '';
    this.details = details;

    Error.captureStackTrace(this);
  }
}
